// extracted by mini-css-extract-plugin
module.exports = {"overline":"Overline-module--overline--2CeYG","primary":"Overline-module--primary--2vIKX"};